import { render, staticRenderFns } from "./QrDispatcher.vue?vue&type=template&id=39df0757"
import script from "./QrDispatcher.vue?vue&type=script&lang=js"
export * from "./QrDispatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports